export default "__VITE_ASSET__j0lJXYsx__"